import { Autocomplete, FormControl, ListItem, TextField, Typography } from "@mui/material";
import type { PassthroughFund } from "../../../../../api/types/passthroughTypes";

interface Props {
  disabled?: boolean;
  value: PassthroughFund | undefined;
  options: PassthroughFund[];
  onChange: (value: PassthroughFund | undefined) => void;
}

const FundControl = ({ disabled, value, options, onChange }: Props) => {
  return (
    <FormControl size="small">
      <Autocomplete
        fullWidth
        value={value || null}
        options={options}
        onChange={(_, value) => onChange(value || undefined)}
        getOptionLabel={({ name }) => name}
        renderInput={(inputProps) => <TextField {...inputProps} placeholder={"Fund"} label={"Fund"} />}
        renderOption={({ key: _key, ...props }, option) => (
          <ListItem key={option.id} {...props}>
            <Typography>{option.name}</Typography>
          </ListItem>
        )}
        disabled={disabled}
        sx={{ "& .MuiAutocomplete-clearIndicator": { display: "none" } }}
      />
    </FormControl>
  );
};

export default FundControl;
